/* eslint-disable @typescript-eslint/no-shadow -- lint gets confused with this rule */
import { Inject, Injectable } from '@angular/core';
import { ActionReducerMap, combineReducers } from '@ngrx/store';
import { LoggerService } from '@safarilaw-webapp/shared/logging';
import { ISafariObjectState, REDUCER, SafariReduxApiObject } from '@safarilaw-webapp/shared/redux';
import { SquirrelValue } from '../squirrel-value/models/app/squirrel-value';
import { SQUIRREL_VALUE_REDUX_OBJECT_TOKEN } from './injectable-object-tokens';
import { SquirrelValue as SquirrelValueModel } from '../squirrel-value/models/app/squirrel-value';
import { ISquirrelState } from './state.interface';

@Injectable({
  providedIn: 'root'
})
export class SquirrelDataAccessObjects {
  constructor(
    @Inject(SQUIRREL_VALUE_REDUX_OBJECT_TOKEN) public SquirrelValue: SafariReduxApiObject<ISafariObjectState<SquirrelValueModel>, SquirrelValueModel>
    /*** BEWARE OF DOG - DO NOT DELETE OR PUT ANYTHING ELSE BELOW THIS (1) ***/
  ) {}
}

@Injectable()
export class ReducerService {
  constructor(
    @Inject(SQUIRREL_VALUE_REDUX_OBJECT_TOKEN) public _squirrel: SafariReduxApiObject<ISafariObjectState<SquirrelValue>, SquirrelValue>,
    private _logger: LoggerService
  ) {}
  get reducers(): ActionReducerMap<ISquirrelState> {
    return {
      squirrelCombinedState: combineReducers({
        squirrelState: REDUCER(this._squirrel, this._logger)
      })
      /*** BEWARE OF DOG - DO NOT DELETE OR PUT ANYTHING ELSE BELOW THIS (2) ***/
    };
  }
}
